module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-range-input",
    style: ({
      width: ((this.width) + "px"),
      'background-color': this.bgColor
    })
  }, [_c('div', {
    staticClass: "vue-range-input__line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slider.upperVal),
      expression: "slider.upperVal"
    }],
    staticClass: "vue-range-input__upper",
    style: (_vm.compUpperStyle),
    attrs: {
      "type": "range",
      "min": _vm.slider.min,
      "max": _vm.slider.max
    },
    domProps: {
      "value": (_vm.slider.upperVal)
    },
    on: {
      "input": _vm.upperSliderOnInput,
      "__r": function($event) {
        _vm.$set(_vm.slider, "upperVal", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.initialVal[1]) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slider.lowerVal),
      expression: "slider.lowerVal"
    }],
    staticClass: "vue-range-input__lower",
    style: (_vm.compLowerStyle),
    attrs: {
      "type": "range",
      "min": _vm.slider.min,
      "max": _vm.slider.max
    },
    domProps: {
      "value": (_vm.slider.lowerVal)
    },
    on: {
      "input": _vm.lowerSliderOnInput,
      "__r": function($event) {
        _vm.$set(_vm.slider, "lowerVal", $event.target.value)
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13fde88e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue-range-input.vue
// module id = 43
// module chunks = 0